import React from "react";
import { FaTrashAlt } from "react-icons/fa";
import { FiMinus } from "react-icons/fi";
import { IoAdd } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { deleteItem, setQuantity } from "../../redux/cartSlice";
import Image from "../../components/designLayouts/Image";

const ItemCard = ({ item }) => {
  const dispatch = useDispatch();
  const price = Number(item?.price?.replaceAll(",", ""));
  const totalPrice = item?.quantity * price;
  const precision = item?.precision || 0;
  const step = Math.pow(10, -precision);
  const maxRegex = new RegExp(`^\\d*(\\.\\d{0,${precision}})?$`);
  const display_stock = Number(sessionStorage.getItem("display_stock"));

  const handleQuantityChange = (e) => {
    const value = e.target.value;
    const parsedValue = parseFloat(value);

    if (display_stock === 3 || display_stock === 2) {
      const quantity = parsedValue >= 0 ? parsedValue : 0;
      dispatch(
        setQuantity({
          _id: item._id,
          quantity,
          size: item.size,
          lot: item.lot,
          color: item.color,
          cupsize: item.cupsize,
        }),
      );
      return;
    }

    if (
      value === "" ||
      (!isNaN(parsedValue) &&
        maxRegex.test(value) &&
        parsedValue >= 0 &&
        parsedValue <= item?.stock)
    ) {
      const quantity = parsedValue > item.stock ? item.stock : parsedValue;
      dispatch(
        setQuantity({
          _id: item._id,
          quantity,
          size: item.size,
          lot: item.lot,
          color: item.color,
          cupsize: item.cupsize,
        }),
      );
    }
  };

  const increaseQuantityHandler = () => {
    const newQuantity = item.quantity + 1;
    if (display_stock === 1) {
      let quantity = newQuantity > item.stock ? item.stock : newQuantity;
      dispatch(
        setQuantity({
          _id: item._id,
          quantity,
          size: item.size,
          lot: item.lot,
          color: item.color,
          cupsize: item.cupsize,
        }),
      );
    } else {
      dispatch(
        setQuantity({
          _id: item._id,
          quantity: newQuantity,
          size: item.size,
          lot: item.lot,
          color: item.color,
          cupsize: item.cupsize,
        }),
      );
    }
  };

  const decreaseQuantityHandler = () => {
    const newQuantity = item.quantity - 1;
    if (display_stock === 1) {
      const quantity = newQuantity < 0 ? 0 : newQuantity;
      dispatch(
        setQuantity({
          _id: item._id,
          quantity,
          size: item.size,
          lot: item.lot,
          color: item.color,
          cupsize: item.cupsize,
        }),
      );
    } else {
      dispatch(
        setQuantity({
          _id: item._id,
          quantity: newQuantity,
          size: item.size,
          lot: item.lot,
          color: item.color,
          cupsize: item.cupsize,
        }),
      );
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US").format(price);
  };

  return (
    <div className="w-full bg-slate-100 shadow-sm rounded-lg p-4 mb-3">
      {/* Main Row: Image & Product Details */}
      <div className="flex flex-row  justify-between gap-2">
        <div className="flex flex-row items-start gap-4">
          <Image
            className="w-20 md:w-24 object-cover rounded-lg"
            aspectRatio={item?.aspect_ratio}
            imgSrc={item?.image}
            alt="product"
          />
          <div className="flex flex-col my-auto">
            <div className="w-[100px] md:w-[150px] lg:w-[200px]">
              <p className="text-xs md:text-sm font-semibold break-words">
                {item?.name || "Unnamed Product"}
              </p>
              <p className="text-xs md:text-sm line-clamp-2 break-words">
                {item?.title}
              </p>
              <p className="text-xs font-light text-gray-400">
                {item?.color && `Color: ${item.color?.name}`}
                {item?.color && (item.size || item.cupsize?.name) && " | "}
                {item?.size && `Size: ${item?.size?.name}`}
                {item?.size && item.cupsize && " | "}
                {item?.cupsize && `Cup Size: ${item?.cupsize?.name}`}
                {item?.lot && `Lot No: ${item?.lot?.lotno}`}
              </p>
            </div>
            <div className="relative h-6 md:h-7 border border-gray-300 rounded-md overflow-hidden flex items-center w-fit mt-2">
              <button
                onClick={decreaseQuantityHandler}
                className="absolute left-0 w-4 md:w-6 h-full bg-gray-100 flex items-center justify-center hover:bg-gray-300 cursor-pointer duration-300"
              >
                <FiMinus size={18} />
              </button>
              <input
                type="number"
                value={item?.quantity}
                min="0"
                step={step}
                onChange={handleQuantityChange}
                className="w-16 md:w-20 h-full text-center text-xs md:text-base border-none outline-none"
              />
              <button
                onClick={increaseQuantityHandler}
                className="absolute right-0 w-4 md:w-6 h-full bg-gray-100 flex items-center justify-center hover:bg-gray-300 cursor-pointer duration-300"
              >
                <IoAdd size={18} />
              </button>
            </div>
            {display_stock === 1 && (
              <p className="text-xs font-light text-gray-400 mt-1">
                <span className="font-semibold">{item.stock}</span> left in
                stock
              </p>
            )}
          </div>
        </div>
        {/* For large screens, show Price & Delete in this row */}
        <div className="hidden lg:flex flex-col items-end my-auto">
          <div className="flex flex-col items-end">
            <p className="text-xs md:text-sm text-end font-medium text-gray-800 break-words">
              Total:{" "}
              <span className="font-semibold">
                {sessionStorage.getItem("cur")}
              </span>{" "}
              {formatPrice(totalPrice)}
            </p>
            <p className="text-xs md:text-sm text-end text-gray-500 break-words">
              Unit:{" "}
              <span className="font-semibold">
                {sessionStorage.getItem("cur")}
              </span>{" "}
              {formatPrice(price)}
            </p>
          </div>
          <button
            onClick={() =>
              dispatch(
                deleteItem({
                  _id: item._id,
                  size: item.size,
                  lot: item.lot,
                  color: item.color,
                  cupsize: item.cupsize,
                }),
              )
            }
            className="text-gray-400 hover:text-red-500 transition mt-2"
          >
            <FaTrashAlt size={16} />
          </button>
        </div>
      </div>
      {/* For screens smaller than lg, show Price & Delete as a separate row */}
      <div className="lg:hidden flex flex-col items-end justify-end mt-4">
        <div className="flex flex-col items-end w-full">
          <p className="text-xs md:text-sm text-end font-medium text-gray-800 break-words">
            Total:{" "}
            <span className="font-semibold">
              {sessionStorage.getItem("cur")}
            </span>{" "}
            {formatPrice(totalPrice)}
          </p>
          <p className="text-xs md:text-sm text-end text-gray-500 break-words">
            Unit:{" "}
            <span className="font-semibold">
              {sessionStorage.getItem("cur")}
            </span>{" "}
            {formatPrice(price)}
          </p>
        </div>
        <button
          onClick={() =>
            dispatch(
              deleteItem({
                _id: item._id,
                size: item.size,
                lot: item.lot,
                color: item.color,
                cupsize: item.cupsize,
              }),
            )
          }
          className="text-gray-400 hover:text-red-500 transition mt-2"
        >
          <FaTrashAlt size={16} />
        </button>
      </div>
    </div>
  );
};

export default ItemCard;
